module.exports = __webpack_public_path__ + "static/img/youcs.71f43ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/youcs.png
// module id = 0on1
// module chunks = 0